import Button from '@ui/button/Button';
import React from 'react';
export function ErrorFallback({ error, resetErrorBoundary }) {
    return (React.createElement("div", { role: "alert", className: "errorfallback" },
        React.createElement("p", null, "Something went wrong:"),
        React.createElement("pre", null, error.message),
        React.createElement(Button, { type: "button", cls: ['button--secondary'], onClick: resetErrorBoundary }, "Try again")));
}
